import { ParsedUrlQuery } from 'node:querystring';
import { IncomingHttpHeaders } from 'node:http';

type HeadersWithXTestContextId = { 'X-Test-Context-Id'?: string };

/**
 * See docs for more information about test context IDs (./docs/test_context_ids.md)
 */
export function headersWithXTestContextIdFrom(query: ParsedUrlQuery): HeadersWithXTestContextId {
  const testContextId = query.testContextId;

  if (!testContextId) {
    return {};
  }

  return {
    'X-Test-Context-Id': testContextId as string,
  };
}

/**
 * Constructs a header object with an 'X-Test-Context-Id' header set if
 * a test context id has been passed either by headers (for a proxied request)
 * or by a query param (for protected routes).
 */
export function headersWithXTestContextIdFromEither(
  headers: IncomingHttpHeaders,
  query: ParsedUrlQuery,
): HeadersWithXTestContextId;
export function headersWithXTestContextIdFromEither(
  headers: Headers,
  query: URLSearchParams,
): HeadersWithXTestContextId;
export function headersWithXTestContextIdFromEither(
  headers: Headers | IncomingHttpHeaders,
  query: URLSearchParams | ParsedUrlQuery,
): HeadersWithXTestContextId {
  let testContextId: string | null;

  if (headers instanceof Headers && query instanceof URLSearchParams) {
    testContextId = headers.get('x-test-context-id') || query.get('testContextId');
  } else {
    testContextId = ((headers as Record<string, unknown>)['x-test-context-id'] ||
      (query as Record<string, unknown>)['testContextId']) as string;
  }

  if (!testContextId) {
    return {};
  }

  return {
    'X-Test-Context-Id': testContextId!,
  };
}
